import * as React from "react";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import axios from "axios";
import FeedbackSurvey from "./FeedbackSurvey";
import { useState } from "react";
import Cookies from "js-cookie";

interface hoverRatingProps {
    shopify_order_id: number;
}

const labels: { [index: string]: string } = {
  1: "Did not like the vibe, spill the tea",
  2: "Double the stars & the scoop. Tell us",
  3: "Verdict time! share your thoughts",
  4: "Missed by a mark, tell us why",
  5: "High five! share your love & review",
};

function getLabelText(value: number) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}

const HoverRating: React.FC<{ shopify_order_id: number }> = ({
    shopify_order_id,
}) => {
  const [value, setValue] = React.useState<number | any | null>(0);
  const [hover, setHover] = React.useState(-1);

  const [show, setShow] = useState(false);


  const [questions, setQuestions] = React.useState<any>(null);
  const [review, setReview] = React.useState<any>(null);

  const fetchData = async () => {

    // const bearerToken = "26d7f5a909d3da9f14958b8436eca2c8";
    const bearerToken = Cookies.get('cookieName');
    const apiURL: any = process.env.REACT_APP_API_URL;
    const url = `https://backend.aqualens.in/app/v1/post-checkout/survey/feedback/questions`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      });

      setQuestions(response.data);
      // console.log(response.data, "dfghjkl"); // Handle the response data here
    } catch (error) {
      console.error(error); // Handle any errors that occur during the request
    }
  };


  const submitOrderReview = async (newValue: any, getLabelText: any) => {
    // const bearerToken = "3d28bbf12acb5b50110f5a13f9335529";
    console.log(getLabelText);
    const bearerToken = Cookies.get('cookieName');
    const url = `https://backend.aqualens.in/api/v1/order/reviews`;
    let ratingData = {
    //   order_id: lenskart_order_id,
      order_id: shopify_order_id,
      rating: newValue,
      review: getLabelText,
    };

    try {
      const response = await axios.post(url, ratingData, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      });

      setReview(response.data);
      // console.log(response.data, "dfghjkl"); // Handle the response data here
    } catch (error) {
      console.error(error); // Handle any errors that occur during the request
    }
  };

  React.useEffect(() => {
    document.body.style.overflow = show ? 'hidden' : 'unset';
  
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);


  return (
    <div className="ratingSection">
      <div className="ratingWrapper">
        <h2>We're All Ears: Rate Your Lens Journey!</h2>
        <Box
          sx={{
            margin: "auto",
            paddingBottom: "14px",
            alignItems: "center",
          }}
        >
          <Rating
            name="hover-feedback"
            value={value}
            precision={1}
            getLabelText={() => getLabelText(value)}
            onChange={(event, newValue:any) => {
              setValue(newValue);
              submitOrderReview(newValue,getLabelText(newValue));
              
            }}
            onChangeActive={(event, newHover) => {
              setHover(newHover);
            }}
            emptyIcon={
              <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
            }
          />
          {value !== null && (
            <Box className="value-css" sx={{ ml: 2 }}>
              {labels[hover !== -1 ? hover : value]}
            </Box>
          )}
        </Box>

        <button className="surveyButtonWrapper" onClick={() =>{ setShow(true); fetchData();}}>
          <span>Join the survey Adventure!</span>
          <svg
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask id="path-1-inside-1_471_2807" fill="white">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.34868 0.875C2.43022 0.875 0.875 2.43022 0.875 4.34868V17.6513C0.875 19.5698 2.43022 21.125 4.34868 21.125H16.6513C18.5698 21.125 20.125 19.5698 20.125 17.6513V4.34868C20.125 2.43022 18.5698 0.875 16.6513 0.875H4.34868ZM9.29513 5.9047C9.12991 5.7309 8.85507 5.72394 8.68126 5.88916C8.50746 6.05439 8.5005 6.32923 8.66572 6.50303L12.434 10.467L8.66572 14.431C8.5005 14.6048 8.50746 14.8797 8.68126 15.0449C8.85507 15.2101 9.12991 15.2032 9.29513 15.0293L13.0634 11.0654C13.3821 10.7301 13.3821 10.2039 13.0634 9.8687L9.29513 5.9047Z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.34868 0.875C2.43022 0.875 0.875 2.43022 0.875 4.34868V17.6513C0.875 19.5698 2.43022 21.125 4.34868 21.125H16.6513C18.5698 21.125 20.125 19.5698 20.125 17.6513V4.34868C20.125 2.43022 18.5698 0.875 16.6513 0.875H4.34868ZM9.29513 5.9047C9.12991 5.7309 8.85507 5.72394 8.68126 5.88916C8.50746 6.05439 8.5005 6.32923 8.66572 6.50303L12.434 10.467L8.66572 14.431C8.5005 14.6048 8.50746 14.8797 8.68126 15.0449C8.85507 15.2101 9.12991 15.2032 9.29513 15.0293L13.0634 11.0654C13.3821 10.7301 13.3821 10.2039 13.0634 9.8687L9.29513 5.9047Z"
              fill="#469DA1"
            />
            <path
              d="M9.29513 5.9047L8.98043 6.20387V6.20387L9.29513 5.9047ZM8.66572 6.50303L8.35102 6.8022L8.66572 6.50303ZM12.434 10.467L12.7487 10.7662L13.0331 10.467L12.7487 10.1679L12.434 10.467ZM8.66572 14.431L8.35102 14.1319L8.66572 14.431ZM9.29513 15.0293L8.98043 14.7302L8.98043 14.7302L9.29513 15.0293ZM13.0634 11.0654L13.3781 11.3645L13.0634 11.0654ZM13.0634 9.8687L12.7487 10.1679H12.7487L13.0634 9.8687ZM1.30921 4.34868C1.30921 2.67003 2.67003 1.30921 4.34868 1.30921V0.440789C2.19041 0.440789 0.440789 2.19041 0.440789 4.34868H1.30921ZM1.30921 17.6513V4.34868H0.440789V17.6513H1.30921ZM4.34868 20.6908C2.67003 20.6908 1.30921 19.33 1.30921 17.6513H0.440789C0.440789 19.8096 2.19041 21.5592 4.34868 21.5592V20.6908ZM16.6513 20.6908H4.34868V21.5592H16.6513V20.6908ZM19.6908 17.6513C19.6908 19.33 18.33 20.6908 16.6513 20.6908V21.5592C18.8096 21.5592 20.5592 19.8096 20.5592 17.6513H19.6908ZM19.6908 4.34868V17.6513H20.5592V4.34868H19.6908ZM16.6513 1.30921C18.33 1.30921 19.6908 2.67003 19.6908 4.34868H20.5592C20.5592 2.19041 18.8096 0.440789 16.6513 0.440789V1.30921ZM4.34868 1.30921H16.6513V0.440789H4.34868V1.30921ZM8.98043 6.20387L8.98043 6.20387L9.60984 5.60554C9.27939 5.25793 8.72971 5.24401 8.3821 5.57446L8.98043 6.20387ZM8.98043 6.20387L8.3821 5.57446C8.03449 5.90491 8.02057 6.45458 8.35102 6.8022L8.98043 6.20387ZM12.7487 10.1679L8.98043 6.20387L8.35102 6.8022L12.1193 10.7662L12.7487 10.1679ZM8.98043 14.7302L12.7487 10.7662L12.1193 10.1679L8.35102 14.1319L8.98043 14.7302ZM8.98043 14.7302L8.35102 14.1319C8.02057 14.4795 8.03449 15.0291 8.3821 15.3596L8.98043 14.7302ZM8.98043 14.7302L8.98043 14.7302L8.3821 15.3596C8.72971 15.69 9.27939 15.6761 9.60984 15.3285L8.98043 14.7302ZM12.7487 10.7662L8.98043 14.7302L9.60984 15.3285L13.3781 11.3645L12.7487 10.7662ZM12.7487 10.1679C12.908 10.3355 12.908 10.5986 12.7487 10.7662L13.3781 11.3645C13.8561 10.8617 13.8561 10.0724 13.3781 9.56953L12.7487 10.1679ZM8.98043 6.20387L12.7487 10.1679L13.3781 9.56953L9.60984 5.60554L8.98043 6.20387Z"
              fill="white"
              mask="url(#path-1-inside-1_471_2807)"
            />
          </svg>
        </button>

       

      </div>

      {show && <FeedbackSurvey show={show} setShow={setShow} />}
    
    </div>
  );
};

export default HoverRating;
